import React, { Component, Fragment } from 'react';
import { getServiceEntity, getZ3PConfigValue } from '../helper';

import OptionDropdown from '../mapper/OptionDropdown';

const toggle = (set, key) => {
  if (set.has(key)) {
    set.delete(key);
  } else {
    set.add(key);
  }
};

export default class CalendarFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.toggleClientLocationId = this.toggleClientLocationId.bind(this);
    this.hasClientLocationId = this.hasClientLocationId.bind(this);
    this.selectAllClientLocationIds = this.selectAllClientLocationIds.bind(
      this,
    );

    this.toggleServiceVehicleId = this.toggleServiceVehicleId.bind(this);
    this.hasServiceVehicleId = this.hasServiceVehicleId.bind(this);
    this.selectAllServiceVehicleIds = this.selectAllServiceVehicleIds.bind(
      this,
    );

    this.toggleServiceType = this.toggleServiceType.bind(this);
    this.hasServiceType = this.hasServiceType.bind(this);
    this.selectAllServiceTypes = this.selectAllServiceTypes.bind(this);
  }

  toggleClientLocationId(clientLocationId) {
    const {
      selectedClientLocationIds,
      setSelectedClientLocations,
    } = this.props;
    toggle(selectedClientLocationIds, clientLocationId);
    setSelectedClientLocations(selectedClientLocationIds);
  }

  hasClientLocationId(clientLocationId) {
    const { selectedClientLocationIds } = this.props;
    return selectedClientLocationIds.has(clientLocationId);
  }

  selectAllClientLocationIds(selected) {
    const { allClientLocations, setSelectedClientLocations } = this.props;

    const allClientLocationIds = new Set();
    if (selected) {
      Object.values(allClientLocations).forEach((l) => {
        allClientLocationIds.add(l.client_location_id.toString());
      });
    }
    setSelectedClientLocations(allClientLocationIds);
  }

  toggleServiceVehicleId(serviceVehicleId) {
    const { selectedServiceVehicles, setSelectedServiceVehicles } = this.props;
    toggle(selectedServiceVehicles, serviceVehicleId);
    setSelectedServiceVehicles(selectedServiceVehicles);
  }

  hasServiceVehicleId(serviceVehicleId) {
    const { selectedServiceVehicles } = this.props;
    return selectedServiceVehicles.has(serviceVehicleId);
  }

  selectAllServiceVehicleIds(selected) {
    const { allServiceVehicleIds, setSelectedServiceVehicles } = this.props;
    if (selected) {
      setSelectedServiceVehicles(allServiceVehicleIds);
    } else {
      setSelectedServiceVehicles(new Set());
    }
  }

  toggleServiceType(serviceType) {
    const { selectedServiceTypes, setSelectedServiceTypes } = this.props;
    toggle(selectedServiceTypes, serviceType);
    setSelectedServiceTypes(selectedServiceTypes);
  }

  hasServiceType(serviceType) {
    const { selectedServiceTypes } = this.props;
    return selectedServiceTypes.has(serviceType);
  }

  selectAllServiceTypes(selected) {
    const { allServiceTypes, setSelectedServiceTypes } = this.props;
    if (selected) {
      setSelectedServiceTypes(Object.keys(allServiceTypes));
    } else {
      setSelectedServiceTypes(new Set());
    }
  }

  render() {
    const {
      allClientLocations,
      allServiceVehicleIds,
      allServiceVehicles,
      allServiceTypes,
    } = this.props;

    const serviceVehicleIdToName = {};
    allServiceVehicles.forEach((sv) => {
      serviceVehicleIdToName[sv.id] = sv.name;
    });

    const clientLocationOptions = Object.values(allClientLocations).map(
      (l) => ({
        id: l.client_location_id,
        name: l.short_name,
      }),
    );
    clientLocationOptions.sort((a, b) => (a.name > b.name ? 1 : -1));

    const serviceVehicleOptions = allServiceVehicleIds.map((svId) => ({
      id: svId,
      name: serviceVehicleIdToName[svId] || svId,
    }));

    const serviceTypeOptions = Object.keys(allServiceTypes).map((type) => ({
      id: type,
      name: `${allServiceTypes[type] || ''} ${type}`,
    }));

    const serviceLocations = getZ3PConfigValue('service_locations');
    const hasWorkplaceServices = serviceLocations?.includes('workplace');
    const hasShopServices = serviceLocations?.includes('shop');

    return (
      <Fragment>
        <OptionDropdown
          categoryName={getServiceEntity()}
          options={serviceVehicleOptions}
          toggleId={this.toggleServiceVehicleId}
          hasId={this.hasServiceVehicleId}
          selectAll={this.selectAllServiceVehicleIds}
        />

        <OptionDropdown
          categoryName="Service Type"
          options={serviceTypeOptions}
          toggleId={this.toggleServiceType}
          hasId={this.hasServiceType}
          selectAll={this.selectAllServiceTypes}
        />

        {(hasWorkplaceServices || hasShopServices) && (
          <OptionDropdown
            categoryName={hasWorkplaceServices ? 'Client Location' : 'Shop'}
            options={clientLocationOptions}
            toggleId={this.toggleClientLocationId}
            hasId={this.hasClientLocationId}
            selectAll={this.selectAllClientLocationIds}
          />
        )}
      </Fragment>
    );
  }
}
